import Vue from 'vue'
import VueRouter from 'vue-router'
import home from './home'
import company from './company'
import application from './application'
import device from './device'
import fota from './fota'
import log from './log'
import message from './message'
import org from './org'
import setting from './setting'
import template from './template'
import user from './user'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'mainView',
    redirect: '/login',
    component: resolve => require(['@/components/mainView.vue'], resolve),
    children: [
      ...home,
      ...company,
      ...application,
      ...org,
      ...user,
      ...device,
      ...template,
      ...fota,
      ...message,
      ...log,
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/pages/login/index.vue'], resolve),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
      path:'/error',
      name:'error',
      component:  resolve => require(['@/pages/result/error.vue'], resolve),
      meta: {
          title: 'error',
          layout: 'blank',
      },
  },
  {
      path:'/404',
      name:404,
      component: resolve => require(['@/pages/result/404.vue'], resolve),
      meta: {
          title: '404未找到',
          layout: 'blank',
      },
  },
  {
      path:"*",
      redirect:"/404"
  },
]


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({routes})
